<div class="notifications-view">
    <h4 class="notification-title">Notifications</h4>
    @if(notifications?.length) {
    <ul class="notifications-list">
        @for(notification of notifications;track notification.trackingId) {
        <li class="notification-list">
            <div class="notification-row">
                <div class="notification-avatar" aria-hidden="true">
                    {{(notification.firstName + ' ' + notification.lastName) |
                    ccdlInitials}}
                </div>
                <div class="notification-content">
                    <div class="notification-message">
                        @let message = getMessageParts(notification);
                        <span>{{message.before}}</span>
                        <strong>{{getTargetName(notification) |
                            titlecase}}</strong>
                        <span>{{message.after}}</span>
                    </div>
                </div>
            </div>
            <div class="notification-footer">
                <span class="notification-time">{{notification.date |
                    ccdlTimeAgo: refreshKey }}</span>
                @if(notification.status === 'REQUEST_RECEIVED') {
                <div class="notification-action">
                    <ccdl-button
                        buttonId="deny_contact_btn"
                        btnLabel="Decline"
                        btnType="default"
                        size="sm"
                        [disabled]="isProcessing"
                        textTransform="capitalize"
                        (onClick)="contactDeclined(notification)"></ccdl-button>
                    <ccdl-button
                        buttonId="accept_contact_btn"
                        btnLabel="Accept"
                        btnType="primary"
                        size="sm"
                        [disabled]="isProcessing"
                        textTransform="capitalize"
                        (onClick)="contactAccepted(notification)"></ccdl-button>
                </div>
                }
            </div>
        </li>
        }
        <li class="notification-list load-more-notifications-btn">
            <ccdl-button
                buttonId="load_more_notifications_btn"
                btnLabel="
                Load More"
                btnType="default"
                size="md"
                textTransform="none"
                (onClick)="loadMoreNotifications()"></ccdl-button>
        </li>
    </ul>
    } @else {
    <div class="no-notifications">
        There are no notifications.
    </div>
    }
</div>